import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import zhCN from './locales/zh-CN.json'
import en from './locales/en.json'
import { getDocumentLang, normalizeLanguage, supportedLanguages } from './language'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': zhCN,
      en,
    },
    supportedLngs: [...supportedLanguages],
    fallbackLng: 'zh-CN',
    load: 'currentOnly',
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => normalizeLanguage(lng) || 'zh-CN',
    },
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = getDocumentLang(lng)
})

document.documentElement.lang = getDocumentLang(i18n.language || 'zh-CN')

export default i18n
